const WEEKDAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS_SHORT   = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function formatDistanceToNow(isoDate: string): string {
  const d      = new Date(isoDate)
  const diffMs = Date.now() - d.getTime()
  const mins   = Math.floor(diffMs / 60_000)
  if (mins < 1)  return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24)  return `${hrs}h ago`
  const days = Math.floor(hrs / 24)
  if (days < 7)  return `${days}d ago`

  try {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  } catch {
    return `${MONTHS_SHORT[d.getMonth()] ?? ''} ${d.getDate()}`
  }
}

export function formatShortDate(isoDate: string): string {
  const d = new Date(isoDate)
  try {
    return d.toLocaleDateString('en-US', { weekday: 'short' })
  } catch {
    return WEEKDAYS_SHORT[d.getDay()] ?? ''
  }
}

export function formatRelativeDays(isoDate: string): string {
  const days = Math.floor((Date.now() - new Date(isoDate).getTime()) / 86_400_000)
  if (days === 0) return 'today'
  if (days === 1) return 'yesterday'
  if (days < 7)   return `${days} days ago`
  if (days < 14)  return 'last week'
  if (days < 30)  return `${Math.floor(days / 7)} weeks ago`
  return `${Math.floor(days / 30)} months ago`
}
